<ng-template #content
             let-customContentTemplate="customContentTemplate"
             let-startIcon="startIcon" let-startIconClasses="startIconClasses" let-startIconOutlined="startIconOutlined"
             let-beforeLabel="beforeLabel" let-beforeLabelClasses="beforeLabelClasses"
             let-label="label" let-labelSize="labelSize"
             let-afterLabel="afterLabel" let-afterLabelClasses="afterLabelClasses"
             let-endIcon="endIcon" let-endIconClasses="endIconClasses" let-endIconOutlined="endIconOutlined">
  @if (customContentTemplate) {
    <span class="mx-button-custom-content">
      <ng-container [ngTemplateOutlet]="customContentTemplate"/>
    </span>
  } @else {
    <span class="mx-button-content">
      @if (startIcon) {
        <mat-icon [class]="startIconClasses" [class.material-icons-outlined]="startIconOutlined">
          {{ startIcon }}
        </mat-icon>
      }

      <span class="empty:hidden" [class.text-title-small]="labelSize === 'small'">
        @if (beforeLabel) {
          <span aria-hidden="true" [class]="beforeLabelClasses">{{ beforeLabel }}</span>
        }

        @if (label) {
          {{ label }}
        }

        @if (afterLabel) {
          <span aria-hidden="true" [class]="afterLabelClasses">{{ afterLabel }}</span>
        }
      </span>

      @if (endIcon) {
        <mat-icon [class]="endIconClasses" [class.material-icons-outlined]="endIconOutlined">
          {{ endIcon }}
        </mat-icon>
      }
    </span>
  }
</ng-template>
